<ng-content></ng-content>

<!-- Tooltip flotante del mini-rail. Posicion `fixed` para escapar el overflow
     del .nav-scroll y la .menu-container. Solo visible en compact. -->
<div class="rail-tooltip"
     *ngIf="compactSig() && hoveredText()"
     [style.top.px]="tooltipTop()"
     [style.left.px]="tooltipLeft()"
     aria-hidden="true">
  {{ hoveredText() }}
  <span *ngIf="hoveredBadge() as b" class="rail-tooltip-badge">{{ b }}</span>
</div>

<!-- Flyout submenu del mini-rail. Aparece cuando el item bajo el cursor es un
     GRUPO (tiene .items). Muestra todos los hijos para que el usuario pueda
     navegar a un L2/L3 sin abrir el sidebar entero. Mismo posicionamiento
     fixed que el tooltip — escapa overflow del .nav-scroll. -->
<div class="rail-flyout"
     *ngIf="compactSig() && flyoutItem() as fly"
     [style.top.px]="fly.top"
     [style.left.px]="tooltipLeft()"
     (mouseenter)="clearFlyoutCloseTimer()"
     (mouseleave)="scheduleFlyoutClose()"
     role="menu"
     [attr.aria-label]="fly.text">
  <header class="rail-flyout-header">{{ fly.text }}</header>
  <ul class="rail-flyout-list" role="list">
    <li *ngFor="let it of fly.items">
      <button type="button"
              class="rail-flyout-item"
              [class.is-group]="it.items?.length"
              (click)="onFlyoutItemClick(it)"
              role="menuitem">
        <app-icon *ngIf="it.icon" [name]="it.icon" [size]="15"></app-icon>
        <span class="rail-flyout-item-label">{{ it.text }}</span>
        <span *ngIf="it.badge as b"
              class="rail-flyout-item-badge"
              [class.is-info]="b.variant === 'info'"
              [class.is-success]="b.variant === 'success'"
              [class.is-warning]="b.variant === 'warning'"
              [class.is-danger]="b.variant === 'danger'"
              [class.is-accent]="b.variant === 'accent'"
              [class.is-neutral]="b.variant === 'neutral'">
          {{ b.text }}
        </span>
      </button>
    </li>
  </ul>
</div>

<!-- Width DINAMICO: en expanded usa el `width` del Input (250 default, o lo que
     el usuario haya arrastrado con el resize handle). En compact NO ponemos
     inline-style — el container toma el ancho del drawer panel-content (48px
     via minSize del layout). Sin esto, en compact el container medía 250px
     aunque el drawer clipeara a 48px → avatar/iconos/botones centrados caian
     en x=125, fuera del viewport visible. -->
<div class="menu-container theme-dependent"
     [style.width.px]="compactSig() ? null : width">
  <div class="menu-glow-top"></div>

  <!-- ========== Top: User card + Search ==========
       Ahora el usuario va arriba. La marca IONICS ya esta en el header de la
       app (no la duplicamos aca). Click → /user-profile. -->
  <div class="nav-top" [class.compact]="compactSig()">
    <button
      type="button"
      class="user-card-top"
      [class.compact]="compactSig()"
      (click)="irAPerfil()"
      [attr.aria-label]="('sidebar.miPerfil' | translate) + ' — ' + (user()?.name || user()?.email || ('sidebar.invitado' | translate))"
      [title]="compactSig() ? (user()?.name || user()?.email || ('sidebar.invitado' | translate)) : null">
      <div class="user-avatar">
        <span class="user-initials">{{ iniciales() }}</span>
        <span class="user-status" [class.online]="estaOnline()" aria-hidden="true"></span>
      </div>
      <div class="user-meta" *ngIf="!compactSig()">
        <div class="user-name" [title]="user()?.name || user()?.email || ''">
          {{ user()?.name || user()?.email || ('sidebar.invitado' | translate) }}
        </div>
        <div class="user-role">
          <span class="role-chip">{{ rolDisplay() || '—' }}</span>
        </div>
      </div>
      <app-icon name="chevronright" class="user-chevron" *ngIf="!compactSig()" [size]="14" aria-hidden="true"></app-icon>
    </button>

    <div class="nav-search" *ngIf="!compactSig()" [class.focused]="searchFocused()" [class.has-value]="searchValue().length > 0">
      <app-icon name="search" class="search-icon" [size]="16" aria-hidden="true"></app-icon>
      <input
        type="text"
        class="nav-search-input"
        [placeholder]="'sidebar.buscarMenu' | translate"
        [value]="searchValue()"
        (input)="searchValue.set($any($event.target).value)"
        (focus)="searchFocused.set(true)"
        (blur)="searchFocused.set(false)" />
      <span class="kbd-hint" *ngIf="!searchValue() && !searchFocused()">
        <kbd>Ctrl</kbd><kbd>M</kbd>
      </span>
      <button
        *ngIf="searchValue()"
        type="button"
        class="search-clear"
        (click)="clearSearch()"
        [attr.aria-label]="'common.limpiar' | translate">
        <app-icon name="close" [size]="14"></app-icon>
      </button>
    </div>
  </div>

  <!-- ========== Tree view (con search) ========== -->
  <div
    class="nav-scroll"
    [class.scrolled-top]="scrolledTop()"
    [class.scrolled-bottom]="scrolledBottom()"
    (scroll)="onScroll($event)">

    <!-- ========== Pinned: items fijados por el usuario ==========
         Solo visible en expanded y si hay al menos uno. Cada boton navega y
         tiene su propio "desfijar" al hover. Persist en localStorage via
         SidebarPinnedService. -->
    <section class="quick-section quick-pinned"
             *ngIf="!compactSig() && pinned.count() > 0">
      <header class="quick-section-header">
        <span class="quick-eyebrow">{{ 'sidebar.fijados' | translate }}</span>
      </header>
      <ul class="quick-list" role="list">
        <li *ngFor="let p of pinned.items()">
          <button type="button"
                  class="quick-item"
                  (click)="navigateToPath(p.path)"
                  [attr.aria-label]="p.label">
            <span class="quick-item-indicator" aria-hidden="true"></span>
            <app-icon [name]="p.icon || 'detailslayout'" class="nav-item-icon" [size]="16"></app-icon>
            <span class="quick-item-text">{{ p.label }}</span>
            <button type="button"
                    class="quick-pin-btn is-pinned"
                    (click)="$event.stopPropagation(); togglePinned({ path: p.path, text: p.label, icon: p.icon })"
                    [attr.aria-label]="'sidebar.desfijar' | translate"
                    [title]="'sidebar.desfijar' | translate">
              <app-icon name="pin" [size]="13"></app-icon>
            </button>
          </button>
        </li>
      </ul>
    </section>

    <!-- ========== Recientes: tracking automático ==========
         Solo visible en expanded y si hay al menos uno. Auto-trackeado por
         SidebarRecentsService que escucha Router.events. -->
    <section class="quick-section quick-recents"
             *ngIf="!compactSig() && recents.count() > 0">
      <header class="quick-section-header">
        <span class="quick-eyebrow">{{ 'sidebar.recientes' | translate }}</span>
      </header>
      <ul class="quick-list" role="list">
        <li *ngFor="let r of recents.items()">
          <button type="button"
                  class="quick-item quick-item-recent"
                  (click)="navigateToPath(r.path)"
                  [attr.aria-label]="r.label">
            <span class="quick-item-indicator" aria-hidden="true"></span>
            <app-icon [name]="r.icon || 'detailslayout'" class="nav-item-icon" [size]="15"></app-icon>
            <span class="quick-item-text">{{ r.label }}</span>
          </button>
        </li>
      </ul>
    </section>

    <!-- Divider sutil entre quick-sections y el menu completo. Solo si hay
         alguna quick-section visible arriba — sino es ruido. -->
    <div class="quick-divider"
         *ngIf="!compactSig() && (pinned.count() > 0 || recents.count() > 0)"
         aria-hidden="true"></div>

    <dx-tree-view
      [items]="items"
      [hidden]="items.length === 0"
      keyExpr="key"
      selectionMode="single"
      [focusStateEnabled]="false"
      expandEvent="click"
      [searchValue]="searchValue()"
      searchExpr="text"
      searchMode="contains"
      [searchEnabled]="false"
      itemTemplate="navItemTpl"
      (onItemClick)="onItemClick($event)"
      width="100%">

      <div *dxTemplate="let item of 'navItemTpl'" class="nav-item-wrap"
           (mouseenter)="onItemHover($event, item)"
           (mouseleave)="onItemLeave()">
        <app-icon *ngIf="item.icon" [name]="item.icon" class="nav-item-icon" [size]="18"></app-icon>
        <span class="nav-item-text">{{ item.text }}</span>
        <span *ngIf="item.badge as b"
              class="nav-item-badge"
              [class.is-info]="b.variant === 'info'"
              [class.is-success]="b.variant === 'success'"
              [class.is-warning]="b.variant === 'warning'"
              [class.is-danger]="b.variant === 'danger'"
              [class.is-accent]="b.variant === 'accent'"
              [class.is-neutral]="b.variant === 'neutral'">
          {{ b.text }}
        </span>
        <!-- Pin / unpin: solo en hojas con path (no en grupos). Visible al hover
             del item; siempre visible cuando ya esta pinned. En compact (rail)
             oculto — el espacio no alcanza. stopPropagation para no disparar
             onItemClick del tree-view (que navegaria al item). -->
        <button *ngIf="item.path && !compactSig()"
                type="button"
                class="quick-pin-btn"
                [class.is-pinned]="pinned.isPinned(item.path)"
                (click)="$event.stopPropagation(); togglePinned(item)"
                [attr.aria-label]="(pinned.isPinned(item.path) ? 'sidebar.desfijar' : 'sidebar.fijar') | translate"
                [title]="(pinned.isPinned(item.path) ? 'sidebar.desfijar' : 'sidebar.fijar') | translate">
          <app-icon name="pin" [size]="13"></app-icon>
        </button>
      </div>
    </dx-tree-view>

    <div *ngIf="navigationService.status() === 'loading' && items.length === 0" class="menu-state loading">
      <dx-load-indicator [visible]="true" width="32" height="32"></dx-load-indicator>
      <span class="state-text">{{ 'sidebar.cargandoModulos' | translate }}</span>
    </div>

    <div *ngIf="navigationService.status() === 'error'" class="menu-state error">
      <app-icon name="warning" [size]="24"></app-icon>
      <p class="state-title">{{ 'sidebar.errorModulos' | translate }}</p>
      <p class="state-hint">{{ 'sidebar.errorModulosHint' | translate }}</p>
      <dx-button
        [text]="'common.reintentar' | translate"
        icon="refresh"
        stylingMode="contained"
        type="default"
        (onClick)="retryLoadMenu()">
      </dx-button>
    </div>

    <div *ngIf="navigationService.status() === 'loaded' && items.length === 0" class="menu-state empty">
      <app-icon name="folder" [size]="24"></app-icon>
      <p class="state-title">{{ 'sidebar.sinModulos' | translate }}</p>
      <p class="state-hint">{{ 'sidebar.sinModulosHint' | translate }}</p>
    </div>
  </div>

  <!-- ========== Controls inline ==========
       Mini-fila con: command palette trigger (⌘K), theme switch, density switch.
       Los 3 son icon buttons compactos. En compact (rail) se apilan vertical. -->
  <div class="nav-controls" [class.compact]="compactSig()">
    <button type="button" class="nav-control-btn nav-control-cmd"
            (click)="openCommandPalette()"
            (mouseenter)="onQuickHover($event, 'commandPalette.titulo', null)"
            (mouseleave)="onItemLeave()"
            [attr.aria-label]="'commandPalette.titulo' | translate">
      <app-icon name="search" [size]="15"></app-icon>
      <span class="nav-control-label" *ngIf="!compactSig()">{{ 'commandPalette.tituloCorto' | translate }}</span>
      <span class="nav-control-kbd" *ngIf="!compactSig()">
        <kbd>⌘</kbd><kbd>K</kbd>
      </span>
    </button>
    <button type="button" class="nav-control-btn nav-control-icon-only"
            (click)="toggleThemeMode()"
            (mouseenter)="onQuickHover($event, 'sidebar.cambiarTema', null)"
            (mouseleave)="onItemLeave()"
            [attr.aria-label]="'sidebar.cambiarTema' | translate"
            [attr.aria-pressed]="isDark()">
      <app-icon [name]="isDark() ? 'sun' : 'moon'" [size]="15"></app-icon>
    </button>
    <button type="button" class="nav-control-btn nav-control-icon-only"
            (click)="toggleDensity()"
            (mouseenter)="onQuickHover($event, 'sidebar.cambiarDensidad', null)"
            (mouseleave)="onItemLeave()"
            [attr.aria-label]="'sidebar.cambiarDensidad' | translate"
            [attr.aria-pressed]="isCompact()">
      <app-icon name="sparkles" [size]="15"></app-icon>
    </button>
  </div>

  <!-- ========== Status bar (Stripe-style) ==========
       Indicador slim de estado de servicios — pulse animado verde + label.
       En compact (rail) solo el pulse, sin texto. El estado real es siempre
       "operativo" por ahora — gancho preparado para conectar a health check. -->
  <div class="nav-status" [class.compact]="compactSig()" role="status">
    <span class="nav-status-pulse" aria-hidden="true"></span>
    <span class="nav-status-label" *ngIf="!compactSig()">
      {{ 'sidebar.serviciosOperativos' | translate }}
    </span>
  </div>

  <!-- ========== Bottom: quick actions ==========
       3 botones: Chat, Configuración (perfil), Salir. Layout horizontal en
       expanded, vertical en compact. Tooltip flotante en compact (mismo que
       los items del menu, via onQuickHover/onQuickLeave). -->
  <div class="nav-bottom" [class.compact]="compactSig()">
    <button type="button" class="quick-btn"
            (click)="irAChat()"
            (mouseenter)="onQuickHover($event, 'sidebar.chat', chatNoLeidos() > 0 ? chatNoLeidos().toString() : null)"
            (mouseleave)="onItemLeave()"
            [attr.aria-label]="('sidebar.chat' | translate) + (chatNoLeidos() > 0 ? ' (' + chatNoLeidos() + ' ' + ('sidebar.sinLeer' | translate) + ')' : '')">
      <app-icon name="message" [size]="18"></app-icon>
      <span class="quick-label" *ngIf="!compactSig()">{{ 'sidebar.chat' | translate }}</span>
      <span class="news-dot" *ngIf="chatNoLeidos() > 0" aria-hidden="true">{{ chatNoLeidos() }}</span>
    </button>

    <button type="button" class="quick-btn"
            (click)="irAPerfil()"
            (mouseenter)="onQuickHover($event, 'sidebar.configuracion', null)"
            (mouseleave)="onItemLeave()"
            [attr.aria-label]="'sidebar.configuracion' | translate">
      <app-icon name="preferences" [size]="18"></app-icon>
      <span class="quick-label" *ngIf="!compactSig()">{{ 'sidebar.configuracion' | translate }}</span>
    </button>

    <button type="button" class="quick-btn quick-btn-danger"
            (click)="cerrarSesion()"
            (mouseenter)="onQuickHover($event, 'sidebar.cerrarSesion', null)"
            (mouseleave)="onItemLeave()"
            [attr.aria-label]="'sidebar.cerrarSesion' | translate">
      <app-icon name="runner" [size]="18"></app-icon>
      <span class="quick-label" *ngIf="!compactSig()">{{ 'sidebar.salir' | translate }}</span>
    </button>
  </div>
</div>
<ng-content select="app-footer"></ng-content>
